const SET_FOCUSED_CONTENT_ORDER_FOR_REVIEW =
  "SET_FOCUSED_CONTENT_ORDER_FOR_REVIEW";
const UNSET_FOCUSED_CONTENT_ORDER_FOR_REVIEW =
  "UNSET_FOCUSED_CONTENT_ORDER_FOR_REVIEW";

export default {
  SET_FOCUSED_CONTENT_ORDER_FOR_REVIEW,
  UNSET_FOCUSED_CONTENT_ORDER_FOR_REVIEW,
};
